import create from 'zustand';

import { FixedNumber } from '../utility';

const useStore = create((set, get) => ({
	activePanel: 'measured',
	activeDBorOctavePanel: 'measuredDB',
	initialMeasurementDistance: 10,
	initialSoundNoise: 100,
	initialSourceSoundPower: 96.8,
	distance: 30,
	initalDistance: 30,
	groundHeight: 80,
	receiverHeight: 3,
	frequency: 500,
	sourceHeight: 2,
	view: { width: 1012, height: 435 },
	scenario: 'noBarriers',
	barrier1: { height: 4, distance: 15 },
	barrier2: { height: 4, distance: 22.5 },
	grid: 'distance',
	showCalculations: false,
	setShowCalculations: (showCalculations) => set((state) => ({ showCalculations })),
	setDistance: (distance) => set((state) => ({
		distance,
		barrier1: { ...state.barrier1, distance: distance * state.barrier1.distance / state.distance },
		barrier2: { ...state.barrier2, distance: distance * state.barrier2.distance / state.distance }
	})),
	getGroundY: () => get().view.height - get().groundHeight,
	getfirstBarrierInitialPosition: () => ({
		x: get().getSoundSourcePosition().x,
		y: get().getGroundY(),
	}),
	getSoundSourcePosition: () => ({
		x: get().view.width * 12.50 / 100, //126.5
		y: get().getGroundY(),
	}),
	getReceiverPosition: () => ({
		x: get().view.width - get().view.width * 12.50 / 100, //885.5
		y: get().getGroundY(),
	}),
	getSingleUnit: () => (get().getReceiverPosition().x - get().getSoundSourcePosition().x) * 0.1 / get().distance,
	getUnitFromMeter: (m) => (get().getReceiverPosition().x - get().getSoundSourcePosition().x) * m / get().distance,
	setSourceHeight: (sourceHeight) => set(() => ({ sourceHeight })),
	setReceiverHeight: (receiverHeight) => set(() => ({ receiverHeight })),
	setViewBox: (width, height) => set(() => ({ view: { width, height } })),
	setBarrierXCoordinate: (barrierXCoordinate) => set(() => ({
		firstBarrier: {
			x: barrierXCoordinate,
		}
	})),
	setinitialMeasurementDistance: (initialMeasurementDistance) => set(() => ({ initialMeasurementDistance })),
	setinitialSoundNoise: (initialSoundNoise) => set(() => ({ initialSoundNoise })),
	setinitialSourceSoundPower: (initialSourceSoundPower) => set(() => ({ initialSourceSoundPower })),
	setinitialFrequency: (frequency) => set(() => ({ frequency })),
	setScenario: (scenario) => set(() => ({ scenario })),
	setGrid: (grid) => set(() => ({ grid })),
	setActivePanel: (activePanel) => set(() => ({ activePanel })),
	setActiveDBorOctavePanel: (activeDBorOctavePanel) => set(() => ({ activeDBorOctavePanel })),
	setBarrier1: (attrs) => set((oldState) => ({ barrier1: { ...oldState.barrier1, ...attrs } })),
	setBarrier2: (attrs) => set((oldState) => ({ barrier2: { ...oldState.barrier2, ...attrs } })),
	setCloseBarrier: (attrs) => set((oldState) => {
		const key = Number(oldState.barrier1.distance) <= Number(oldState.barrier2.distance) ? 'barrier1' : 'barrier2';
		return {
			[key]: { ...oldState[key], ...attrs }
		};
	}),
	setFarBarrier: (attrs) => set((oldState) => {
		const key = Number(oldState.barrier1.distance) > Number(oldState.barrier2.distance) ? 'barrier1' : 'barrier2';
		return {
			[key]: { ...oldState[key], ...attrs }
		};
	}),
	setBarriers: (closeBarrier, farBarrier) => set((oldState) => {
		const [closeBarrierKey, farBarrierKey] = Number(oldState.barrier1.distance) <= Number(oldState.barrier2.distance) ? ['barrier1', 'barrier2'] : ['barrier2', 'barrier1'];
		return {
			[closeBarrierKey]: {
				...oldState[closeBarrierKey],
				...closeBarrier,
			},
			[farBarrierKey]: {
				...oldState[farBarrierKey],
				...farBarrier,
			}
		};
	}),
	setGroundDistances: ({ sourceToBarrier, barrierToBarrier, barrierToReceiver }) => set((oldState) => {
		const [closeBarrierKey, farBarrierKey] = Number(oldState.barrier1.distance) <= Number(oldState.barrier2.distance) ? ['barrier1', 'barrier2'] : ['barrier2', 'barrier1'];
		if (sourceToBarrier) {
			const offset = oldState[closeBarrierKey].distance - sourceToBarrier;
			return {
				[closeBarrierKey]: {
					...oldState[closeBarrierKey],
					distance: sourceToBarrier
				},
				[farBarrierKey]: {
					...oldState[farBarrierKey],
					distance: FixedNumber(oldState[farBarrierKey].distance - offset),
				},
				distance: FixedNumber(oldState.distance - offset),
			};
		}
		if (barrierToBarrier) {
			const offset = oldState[farBarrierKey].distance - oldState[closeBarrierKey].distance - barrierToBarrier;
			return {
				[farBarrierKey]: {
					...oldState[farBarrierKey],
					distance: FixedNumber(oldState[farBarrierKey].distance - offset),
				},
				distance: FixedNumber(oldState.distance - offset),
			};
		}
		if (barrierToReceiver) {
			const newState = {};

			if (oldState.scenario === 'singleBarrier') {
				const offset = oldState.distance - oldState['barrier1'].distance - barrierToReceiver;
				newState.distance = FixedNumber(oldState.distance - offset);
				newState.barrier2 = {
					...oldState.barrier2,
					distance: FixedNumber(oldState.barrier1.distance + (newState.distance - oldState.barrier1.distance) / 2),
				};
			} else {
				const offset = oldState.distance - oldState[farBarrierKey].distance - barrierToReceiver;
				newState.distance = FixedNumber(oldState.distance - offset);
			}

			return newState;
		}
	}),
}));

export default useStore;

// getUnitFromMeter: Returns a representation in meters in the svg view size
